import createIcon from '../../createIcon';

/**
 * @component @name Logout
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTcgN0wxNS41OSA4LjQxTDE4LjE3IDExSDhWMTNIMTguMTdMMTUuNTkgMTUuNThMMTcgMTdMMjIgMTJMMTcgN1pNNCA1SDEyVjNINEMyLjkgMyAyIDMuOSAyIDVWMTlDMiAyMC4xIDIuOSAyMSA0IDIxSDEyVjE5SDRWNVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Logout = createIcon('Logout', [
  [
    'path',
    {
      d: 'M17 7L15.59 8.41L18.17 11H8V13H18.17L15.59 15.58L17 17L22 12L17 7ZM4 5H12V3H4C2.9 3 2 3.9 2 5V19C2 20.1 2.9 21 4 21H12V19H4V5Z',
      key: '1fz0gc',
    },
  ],
]);

export default Logout;
